/** 本文件由工具自动生成,请勿手动修改！ **/
// @ts-nocheck
import { useState,  useEffect } from 'react';
import * as R from 'ramda';
import Request, { YWRequestConfig } from '@ywfe/request';
import { getHost, reduceParams, parseParams, querystring } from '@ywfe/utils';


const { basePath = '', loginPath = '' } = getHost("PROAUTH", "88")




  export type API11940Req = {};



export interface API11940Res {
  /**   */
  code: number;
  /**   */
  msg: string;
  
};


// 11940 用户退出

export interface IUseGetAPI11940Return {
  /** 用户退出: 接口请求状态 */
  isAPI11940Loading: boolean;
  /** 用户退出: 接口请求返回数据 */
  dataAPI11940: API11940Res;
  /**  用户退出: 接口数据请求方法 */
  fetchAPI11940Data:  ( config?: YWRequestConfig) => Promise<API11940Res>;
  /** 用户退出: 接口请求URL */
  requestUrl: string;
}

export const useGetAPI11940 = ():IUseGetAPI11940Return => {
  let isMount = true;
  const [isAPI11940Loading, setIsAPI11940Loading] = useState(false);
  const [dataAPI11940, setDataAPI11940] = useState<API11940Res>({} as API11940Res);
  const requestUrl = `${basePath}/ywwl-admin/user/logout`;

  const fetchAPI11940Data = async ( config?: YWRequestConfig): Promise<API11940Res> => {
  
    if ( isMount ) {
      setIsAPI11940Loading(true);
    }

    try {
      
      
      const res: any = await Request.get<API11940Res>(`${basePath}/ywwl-admin/user/logout`, {
        loginHost: loginPath,
        ...config
      });
      
      
      
      if (isMount) {
        setDataAPI11940(res || {} as API11940Res);
        setIsAPI11940Loading(false);
      }
      return res;
    } catch (error) {
      console.error('[ERROR] API Request Error: ', error);
      if ( isMount ) {
        setIsAPI11940Loading(false);
      }
      return false as unknown as API11940Res;
    }
  }

  useEffect(() => {
    return () => {
      isMount = false;
    };
  }, []);

  return {
    isAPI11940Loading,
    dataAPI11940,
    fetchAPI11940Data,
    requestUrl,
  }
}

